import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tabGroup: {
		id: 'navigation-kit-tab-list-old.tab-group',
		defaultMessage: 'Project view',
		description: 'Label of the list of tabs',
	},
	projectNavigation: {
		id: 'navigation-kit-tab-list-old.project-navigation',
		defaultMessage: 'Project Navigation',
		description: 'Label for skip link to project navigation',
	},
});
